export const breakpoints = {
  modalContentMedium: '860px',
  modalSmall: '700px'
}
